import '../css/main.less';

require('./slick.min');
// require('surveyjs-editor');

import 'core-js/fn/object/assign';
import SearchBar from "widgets/search-bar/widget";

let Barba = require('barba.js'),
    Transitions = require('./transitions'),
    Layout = require('./layout'),
    MainPage = require('./views/main-page'),
    MapPage = require('./views/map-page'),
    RentPage = require('./views/rent-page'),
    ContactsPage = require('./views/contacts-page'),
    CatalogPage = require('./views/catalog-page'),
    CompanyPage = require('./views/company-page'),
    EventPage = require('./views/event-page'),
    searchBar = new SearchBar();
// Асинхрнные переходы
function AsynchronousTransitions() {
    Barba.Pjax.cacheEnabled = false;
    Barba.Pjax.getTransition = function () {
        return Transitions.OpacityTransition;
    };

    MainPage.init();
    MapPage.init();
    RentPage.init();
    ContactsPage.init();
    CatalogPage.init();
    CompanyPage.init();
    EventPage.init();

    Barba.Pjax.start();
}

$(document).ready(function () {
    AsynchronousTransitions();
    Layout();
    
});

const elementCookieConsent = document.getElementById('cookie-consent');
const elementButtonAccept = document.getElementById('accept-cookies');
function renderCookie() {
  const currentStateCookie = localStorage.getItem('cookie_consent');
  if (currentStateCookie !== 'true') {
    elementCookieConsent.style.display = 'flex';
  } else {
    elementCookieConsent.style.display = 'none';
  }
}
function clickHandlerAcceptCookie() {
  localStorage.setItem('cookie_consent', 'true');
  elementCookieConsent.style.display = 'none';
}
document.addEventListener('DOMContentLoaded', renderCookie);
elementButtonAccept.addEventListener('click', clickHandlerAcceptCookie);



// WEBPACK FOOTER //
// resources/assets/src/js/main.js